export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";
export const UPDATE_CSRF_TOKEN = "UPDATE_CSRF_TOKEN";

export const DEPLOY_SNACKBAR = "DEPLOY_SNACKBAR";
export const UPDATE_SNACKBAR = "UPDATE_SNACKBAR";

export const UPDATE_QUESTION_SEARCH_PARAMS = "UPDATE_QUESTION_SEARCH_PARAMS";
export const UPDATE_ANSWER_SEARCH_PARAMS = "UPDATE_ANSWER_SEARCH_PARAMS";
